import axios from "../http-client/axios";
import { PARAMORE_URL } from "../urls/base-urls";


export async function getLinks() {
   
  const resp = await axios({
    url: `${PARAMORE_URL}/links`,
    // url: `http://localhost:8304/links`,
    method: "get",
    data: {},
    headers: { "content-type": "application/json"},
  });
  
  return resp.data;
}

export async function getLinkByType(type) {
   
  const resp = await axios({
    url: `${PARAMORE_URL}/link/${type}`,
    // url: `http://localhost:8304/link/${type}`,
    method: "get",
    data: {},
    headers: { "content-type": "application/json"},
  });
  
  return resp.data;
}

export async function updateLink(formData) {
  const request =  {
    id: formData.id,
    code: formData.code,
    description: formData.description,
  }

  const resp = await axios({
    url: `${PARAMORE_URL}/link`,
    // url: `http://localhost:8304/link`,
    method: "put",
    data: request,
    headers: { "content-type": "application/json" },
  });

  return resp.data;
}
